var Layout    = require("enyo/Layout"),
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables.js");

require("app/theme/IconButton--transparent-light.less");
require("app/theme/IconButton--close.less");
require("app/theme/IconButton--radiant.less");

module.exports = kind(/** @lends  app.MediaPlayer.AudioViewLayout.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.AudioViewLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var container           = this.container,
            controller          = container.controller,
            $thumbnailContainer = container.$.thumbnailContainer,
            $thumbnail          = container.$.thumbnail,
            $expandButton       = container.$.expandButton;

        if (!container.hasNode() || !controller) {
            return;
        }

        // Reset thumbnail scale
        $thumbnailContainer.addStyles({
            width:  null,
            height: null
        });
        $thumbnail.addStyles({
            width:  null,
            height: null
        });
        $expandButton.addStyles({
            width:  null,
            height: null
        });

        // Layout based on display mode
        switch (controller.get("displayMode")) {
            case "minimized":
                this.minimizedLayout();
                break;
            case "footer":
                this.footerLayout();
                break;
            case "maximized":
            default:
                this.maximizedLayout();
                break;
        }
    },

    /**
     * Displays the media player at full size. Filling the entire contentRegion
     * of the app layout.
     */
    maximizedLayout: function() {
        var container           = this.container,
            appView             = container.app.view,
            headerRegionBounds  = appView.get("headerRegionBounds") || {},
            headerRegionHeight  = headerRegionBounds.height || 0,
            $backButton         = container.$.backButton,
            $prevMediaButton    = container.$.prevMediaButton,
            $nextMediaButton    = container.$.nextMediaButton,
            $thumbnailContainer = container.$.thumbnailContainer,
            $thumbnail          = container.$.thumbnail,
            containerBounds,
            headerOverlap,
            thumbnailSize;

        // Switch styles as needed
        $backButton.set("theme", "transparent-light");
        $prevMediaButton.set("theme", "radiant");
        $nextMediaButton.set("theme", "radiant");
        container.setAttribute("data-display-mode", "maximized");

        // Scale thumbnail
        containerBounds = $thumbnailContainer.getBounds();
        headerOverlap   = themeVars.appHeaderFloat ? headerRegionHeight : 0;
        thumbnailSize   = Math.min(

            // 80% of container height after subtracting safe area and header
            // overlap
            (containerBounds.height - themeVars.safeAreaInsetTop - headerOverlap) * 0.8,

            // Container height after subtracting safe area, header overlap and
            // 2 times standard vertical padding
            containerBounds.height - themeVars.safeAreaInsetTop - headerOverlap - themeVars.getContentPaddingVerticalPx() * 2,

            // 80% of container width after subtracting safe area
            (containerBounds.width - themeVars.safeAreaInsetLeft - themeVars.safeAreaInsetRight) * 0.8,

            // Container width after subtracting safe area and 2 times large
            // page margin
            containerBounds.width - Math.max(themeVars.safeAreaInsetLeft, themeVars.getPageMarginLargePx()) - Math.max(themeVars.safeAreaInsetRight, themeVars.getPageMarginLargePx())
        );
        $thumbnail.setBounds({
            width:  thumbnailSize,
            height: thumbnailSize
        });
    },

    /**
     * Displays the media player in the bottom-right of the screen.
     */
    footerLayout: function() {
        var container           = this.container,
            $expandButton       = container.$.expandButton,
            $prevMediaButton    = container.$.prevMediaButton,
            $nextMediaButton    = container.$.nextMediaButton,
            $closeButton        = container.$.closeButton,
            $metadata           = container.$.metadata,
            $playerContainer    = container.$.playerContainer,
            $thumbnailContainer = container.$.thumbnailContainer,
            thumbnailSize;

        // Switch styles as needed
        $expandButton.set("theme", "transparent-light");
        $prevMediaButton.set("theme", "radiant");
        $nextMediaButton.set("theme", "radiant");
        $closeButton.set("theme", "radiant");
        container.setAttribute("data-display-mode", "footer");

        // Scale Thumbnail
        if (["medium", "large"].includes(themeVars.formFactor)) {
            thumbnailSize = $metadata.getBounds().height + themeVars.getContentPaddingVerticalPx() + $playerContainer.getBounds().height;
        }
        else if (themeVars.formFactor === "small") {
            thumbnailSize = $metadata.getBounds().height + themeVars.getContentPaddingVerticalPx() * 2;
        }
        else if (themeVars.formFactor === "smaller") {
            thumbnailSize = $metadata.getBounds().height + themeVars.getContentPaddingVerticalCompactPx() * 2;
        }
        else {
            thumbnailSize = 0;
        }
        $thumbnailContainer.setBounds({
            width:  thumbnailSize,
            height: thumbnailSize
        });
        $expandButton.setBounds({
            width:  thumbnailSize,
            height: thumbnailSize
        });
    },

    /**
     * Displays the media player at the bottom of the screen.
     */
    minimizedLayout: function() {
        var container           = this.container,
            $expandButton       = container.$.expandButton,
            $playPauseButton    = container.$.playPauseButton,
            $closeButton        = container.$.closeButton,
            $metadata           = container.$.metadata,
            $thumbnailContainer = container.$.thumbnailContainer,
            thumbnailSize;

        $expandButton.set("theme", "transparent-light");
        $playPauseButton.set("theme", "radiant");
        $closeButton.set("theme", "radiant");
        container.setAttribute("data-display-mode", "minimized");

        // Scale Thumbnail
        if (themeVars.formFactor === "tiny") {
            thumbnailSize = 0;
        }
        else {
            thumbnailSize = $metadata.getBounds().height + themeVars.getContentPaddingVerticalCompactPx() * 2;
        }
        $thumbnailContainer.setBounds({
            width:  thumbnailSize,
            height: thumbnailSize
        });

        // Scale Expand Button
        if (themeVars.formFactor !== "tiny") {
            $expandButton.setBounds({
                width:  thumbnailSize,
                height: thumbnailSize
            });
        }
    }

});
